import Application from "../../Application";
import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class SetFormVersionForAnnouncementInteractor {
  private application: Application;
  private applicantFormService: IApplicantFormService;

  constructor(application, applicantFormService) {
    this.application = application;
    this.applicantFormService = applicantFormService;
  }

  async execute(formVersionId: number, forAnnouncement?: string) {
    return this.applicantFormService.setFormVersionForAnnouncement(
      formVersionId,
      forAnnouncement
    );
  }
}
